export default __webpack_public_path__ + "static/media/bbank-closed-logo.78ed3809.svg";